import React from 'react';
import { GlobalStyles, useTheme } from '@mui/material';

const IonicTheme = () => {
  const theme = useTheme();

  return (
    <GlobalStyles
      styles={{
        ':root': {
          '--ion-color-primary': theme.palette.primary.main,
          '--ion-color-primary-contrast': theme.palette.primary.contrastText,
          '--ion-color-secondary': theme.palette.secondary.main,
          '--ion-font-family': theme.typography.fontFamily,
          '--ion-border-radius': `${theme.shape.borderRadius}px`,
          '--ion-background-color': theme.palette.background.default,
          '--ion-text-color': theme.palette.text.primary,
          '--ion-color-primary-shade': theme.palette.primary.dark,
          '--ion-color-primary-tint': theme.palette.primary.light,
        },

        'ion-button': {
          fontFamily: theme.typography.fontFamily,
          textTransform: 'uppercase',
        },
        'ion-button::part(native)': {
          background: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          borderRadius: `${theme.shape.borderRadius}px`,
        },
      }}
    />
  );
};

export default IonicTheme;
